import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Ana Sayfa', path: '/' },
    { name: 'Hakkımızda', path: '/about' },
    { name: 'Ürünler', path: '/products' },
    { name: 'Üretim & Kalite', path: '/production-quality' },
  ];

  const moreLinks = [
    { name: 'Sürdürülebilirlik', path: '/sustainability' },
    { name: 'İhracat', path: '/export' },
    { name: 'İletişim', path: '/contact' },
  ];

  const products = [
    { name: 'PET Şişe', path: '/products#pet-sise' },
    { name: 'PET Kavanoz', path: '/products#pet-kavanoz' },
    { name: 'PET Preform', path: '/products#pet-preform' },
    { name: 'PP Kapak', path: '/products#pp-kapak' },
  ];

  const socialLinks = [
    { icon: 'ri-linkedin-fill', url: '#', name: 'LinkedIn' },
    { icon: 'ri-instagram-line', url: '#', name: 'Instagram' },
    { icon: 'ri-facebook-fill', url: '#', name: 'Facebook' },
    { icon: 'ri-youtube-fill', url: '#', name: 'YouTube' },
  ];

  const contactInfo = [
    { icon: 'ri-map-pin-line', text: 'Erek Mah. Selçuklu Cad. No:49/1, Erbaa, Turkey' },
    { icon: 'ri-phone-line', text: '+90 (356) 502 81 19' },
    { icon: 'ri-mail-line', text: 'info@anadolupetambalaj.com' },
  ];

  return (
    <footer className="bg-gradient-to-br from-navy via-navy to-navy/95 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-0 w-96 h-96 bg-green rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-teal rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12 mb-12 lg:mb-16">
          {/* Company Info */}
          <div className="md:col-span-2 lg:col-span-2">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/796e0aee0d5cd4a0868b526e4f3ec27c.png" 
                alt="AnadoluPet Logo" 
                className="h-12 sm:h-14 w-auto"
              />
            </div>
            <p className="text-white/70 text-sm sm:text-[15px] leading-relaxed mb-6 sm:mb-8">
              Anadolu Pet Ambalaj güvencesiyle, Avrupa standartlarında yüksek kaliteli PET ambalaj üretimi. Gıda ve endüstriyel sektörlere özel, sürdürülebilir ambalaj çözümleri.
            </p>
            
            <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
              {contactInfo.map((info, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${info.icon} text-green text-base`} />
                  </div>
                  <span className="text-white/70 text-sm">{info.text}</span>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={social.name}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 border border-white/10 text-white hover:bg-green hover:border-green transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-bold uppercase mb-4 sm:mb-6 text-white tracking-wider">KURUMSAL</h3>
            <ul className="space-y-2 sm:space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/70 text-sm sm:text-[15px] hover:text-green hover:translate-x-1 transition-all duration-300 cursor-pointer inline-block"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* More Links */}
          <div>
            <h3 className="text-sm font-bold uppercase mb-4 sm:mb-6 text-white tracking-wider">HIZMETLER</h3>
            <ul className="space-y-2 sm:space-y-3">
              {moreLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/70 text-sm sm:text-[15px] hover:text-green hover:translate-x-1 transition-all duration-300 cursor-pointer inline-block"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-sm font-bold uppercase mb-4 sm:mb-6 text-white tracking-wider">ÜRÜNLER</h3>
            <ul className="space-y-2 sm:space-y-3">
              {products.map((product) => (
                <li key={product.path}>
                  <Link
                    to={product.path}
                    className="text-white/70 text-sm sm:text-[15px] hover:text-green hover:translate-x-1 transition-all duration-300 cursor-pointer inline-block"
                  >
                    {product.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Newsletter Section */}
        <div className="bg-white/5 backdrop-blur-sm rounded-xl lg:rounded-2xl p-6 sm:p-8 lg:p-10 border border-white/10 mb-12 lg:mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-center">
            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-2 sm:mb-3">Haberdar Olun</h3>
              <p className="text-white/70 text-sm">
                Yeni ürünler, kampanyalar ve sektörel gelişmelerden haberdar olmak için bültenimize abone olun.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-1 px-4 sm:px-5 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:border-green transition-colors text-sm"
              />
              <button className="px-6 sm:px-8 py-3 bg-green text-white text-sm font-semibold rounded-lg hover:bg-green-dark transition-all duration-300 whitespace-nowrap cursor-pointer">
                Abone Ol
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6">
            <p className="text-white/60 text-xs sm:text-sm text-center sm:text-left">
              © {currentYear} AnadoluPet Ambalaj. Tüm hakları saklıdır.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 lg:gap-8 text-xs sm:text-sm">
              <a href="#" className="text-white/60 hover:text-green transition-colors cursor-pointer whitespace-nowrap">
                Gizlilik Politikası
              </a>
              <a href="#" className="text-white/60 hover:text-green transition-colors cursor-pointer whitespace-nowrap">
                Çerez Politikası
              </a>
              <a href="#" className="text-white/60 hover:text-green transition-colors cursor-pointer whitespace-nowrap">
                Kullanım Koşulları
              </a>
              <a 
                href="https://cdco.com.tr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white/60 hover:text-green transition-colors cursor-pointer whitespace-nowrap"
              >
                Bu Web Tasarımı CDCO tarafından yapılmıştır
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
